import { UILobbyTableRowController } from './UILobbyTableRowController.ts';
import { SocketLobbySend } from '../../socket/SocketLobbySend.ts';
import { UILobbyTableHeaderController } from './UILobbyTableHeaderController.ts';
import { GameSorter } from '../../../../../shared/GameSorter.ts';
import { UIAjaxWrapper } from '../../network/UIAjaxWrapper.ts';
import { UIAPIEndpoints } from '../../network/UIAPIEndpoints.ts';
import { logError } from '../../ui_utils/Utils.ts';
import { createGloballyExclusiveHandler } from '../../ui_utils/ClientUtils.ts';
import { UILobbyRoomListController } from './UILobbyRoomListController.ts';
import { uiManagerEvents } from '../../EntryShared.ts';
export class UILobbyTableController {
    show() {
        this.visible = true;
        this.updateRoomListDisplay();
    }
    hide() {
        this.visible = false;
        this.updateRoomListDisplay();
    }
    updateRoomList(data) {
        var _this_roomList;
        (_this_roomList = this.roomList) === null || _this_roomList === void 0 ? void 0 : _this_roomList.update(data);
    }
    onGotKicked(roomId, canRejoin) {
        var _this_roomList;
        if (canRejoin) return;
        this.kickedFromRooms.add(roomId);
        (_this_roomList = this.roomList) === null || _this_roomList === void 0 ? void 0 : _this_roomList.setRoomUnavailable(roomId);
    }
    updateRoomListDisplay() {
        var _this_roomList;
        (_this_roomList = this.roomList) === null || _this_roomList === void 0 ? void 0 : _this_roomList.destroy();
        this.roomList = undefined;
        if (this.visible && this.headerController.isRoomListActive()) {
            const tableBody = document.getElementById('lobby_center_rooms_table_body');
            const header = document.getElementById('lobby_center_table_rooms_tab_div');
            this.roomList = new UILobbyRoomListController(tableBody, header, UILobbyTableController.createClickedJoinRoomCallback(), this.kickedFromRooms);
            this.roomList.activate();
        }
    }
    static createClickedJoinRoomCallback() {
        return createGloballyExclusiveHandler(async (gameId)=>{
            await uiManagerEvents.createClickedJoinRoomCallback(gameId);
        });
    }
    async refreshGames() {
        this.headerController.updateLastRefreshTimestamp();
        const data = await UIAjaxWrapper.getRequestHandler(UIAPIEndpoints.apiGetGameList(), undefined, undefined, false);
        if (data === undefined) {
            return logError('refreshGames', [
                'Network error'
            ]);
        }
        this.updateSpectateGames(data.json);
    }
    updateSpectateGames(newData) {
        this.headerController.showActiveTableBody();
        UILobbyTableController.removeLobbyTableRows(this.spectateRows);
        const sortedLobbyRowData = this.gameSorter.sort(newData.games);
        this.spectateRows = this.createLobbyTableRows(sortedLobbyRowData, this.spectateTableBody, UILobbyTableController.createClickedSpectateRoomCallback());
    }
    static createClickedSpectateRoomCallback() {
        return createGloballyExclusiveHandler(async (gameId)=>{
            await SocketLobbySend.clickedSpectateGame(gameId);
        });
    }
    static removeLobbyTableRows(rows) {
        rows.forEach((row)=>{
            row.remove();
        });
        rows.length = 0;
    }
    // eslint-disable-next-line class-methods-use-this
    createLobbyTableRows(lobbyRowData, container, clickAction) {
        const rows = [];
        for (const rowItem of lobbyRowData){
            const lobbyRow = new UILobbyTableRowController(container, rowItem, clickAction);
            lobbyRow.update(rowItem);
            rows.push(lobbyRow);
        }
        return rows;
    }
    constructor(){
        this.spectateRows = [];
        this.gameSorter = new GameSorter();
        this.kickedFromRooms = new Set();
        this.visible = false;
        this.headerController = new UILobbyTableHeaderController(()=>this.refreshGames(), ()=>this.updateRoomListDisplay());
        this.spectateTableBody = document.getElementById('lobby_center_spectate_table_body');
    }
}
